import { memo, useMemo } from 'react';
import { useTranslation } from '@hooks';
import ReviewsDistributionChart from './ReviewsDistributionChart';

const DAYPART_KEYS = ['morning', 'afternoon', 'evening'];

const ReviewsByDaypart = memo(({ data, styles }) => {
    const { t } = useTranslation();

    const labels = DAYPART_KEYS.map(key => t(`AnalyticsReviews.${key}`));
    const legends = [t('AnalyticsReviews.positiveReviews'), t('AnalyticsReviews.negativeReviews')];

    const { positiveData, negativeData } = useMemo(() => {
        const positive = new Array(3).fill(0);
        const negative = new Array(3).fill(0);
        data.forEach(item => {
            positive[item.daypart] = item.averagePositiveReviews ?? 0;
            negative[item.daypart] = item.averageNegativeReviews ?? 0;
        });
        return { positiveData: positive, negativeData: negative };
    }, [data]);

    return (
        <ReviewsDistributionChart
            title={t('AnalyticsReviews.reviewsByDaypart')}
            labels={labels}
            positiveData={positiveData}
            negativeData={negativeData}
            legends={legends}
            chartId="reviews-by-daypart-chart-wrapper"
            styles={styles}
        />
    );
});

ReviewsByDaypart.displayName = 'ReviewsByDaypart';

export default ReviewsByDaypart;
